@use "../../styles/variables" as *;
@use "../../styles/mixins" as *;

/* Colors
------------------------------------ */
$cookie-banner-background-color: $white;
$text-color: $grey;
$link-color: $grey;
$button-background-color: $grey;
$button-text-color: $white;

* {
  font-family: Roboto, sans-serif;
  box-sizing: border-box;
}

.cookie-banner {
  display: none;

  &.active {
    position: fixed;
    bottom: 0;
    width: 100%;
    animation-duration: 0.8s;
    animation-name: slideUp;
    display: flex;
    flex-direction: column;
    background: $cookie-banner-background-color;
    z-index: 1000;

    @include desktop {
      flex-direction: row;
    }

    p {
      margin: 0;
      font-size: .75rem;
      color: $text-color;
      padding: 1.25rem 1.25rem 0 1.125rem;
      white-space: pre-line;

      @include desktop {
        white-space: unset;
        padding: 2.25rem;
      }

      a {
        color: $link-color;
      }

      button {
        font-size: .75rem;
        color: $link-color;
        border: none;
        background: $cookie-banner-background-color;
        padding: 0;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .close {
      position: absolute;
      right: .5rem;
      top: .5rem;
      cursor: pointer;

      img {
        display: block;
        width: 1rem;
      }
    }

    .cookie-banner-content {
      flex: 1;
    }

    .cookie-banner-controls {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 1.75rem 0 2.75rem;

      @include desktop {
        flex: 1;
        flex-direction: row;
        margin: auto 2.5rem auto;
        justify-content: center;
        flex-wrap: wrap;
      }

      @include fullhd {
        justify-content: flex-end;
      }

    button {
      border: none;
      background: $button-background-color;
      color: $button-text-color;
      padding: .75rem 1.25rem;
      text-transform: uppercase;
      font-size: .75rem;
      line-height: .75rem;
      letter-spacing: .6px;
      min-width: 66%;
      cursor: pointer;
      border-radius: 24px;

        &:not(:first-of-type),
        &:not(:last-of-type) {
          margin: .375rem 0;

          @include desktop {
            margin: .5rem;
          }
        }

        @include desktop {
          min-width: unset;
        }
      }
    }
  }
}

/* Fade in up
------------------------------------ */
@keyframes slideUp {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
}
